module.exports = __webpack_public_path__ + "media/thirdSection/5-ce1128af.png";